import ViewDocumentsContainer from "./ViewDocumentsContainer";

const ViewDocuments = ({ customBaseDetailPath = "/client-detail/" }) => {
  return <ViewDocumentsContainer customBaseDetailPath={customBaseDetailPath} />;
};

export default ViewDocuments;
